//@flow

export function isMobile() {
  return ('ontouchstart' in window) || (navigator.maxTouchPoints);
}

export function isIOS():boolean {
  if (navigator && window) {
    return (/iPhone|iPod/.test(navigator.userAgent) && !window.MSStream);
  }
  return false;
}

export function isFacebook():boolean {
  if (navigator && window) {
    return /FBAN|FBAV/.test(navigator.userAgent);
  }
  return false;
}

//deal with IOS issue in which inputs move around when in a fixed modal https://stackoverflow.com/questions/46339063/ios-11-safari-bootstrap-modal-text-area-outside-of-cursor
//frozen class is handled in shell.react by handleTouchStart logic
export function toggleFreezeBody() {
  if (!document || !document.body) return;
  const classList = document.body.classList;
  if (!classList) return;
  if (classList.contains('frozen')) {
    return classList.remove('frozen');
  }
  return classList.add('frozen');
}
